<!-- eslint-disable vue/require-component-is -->
<template>
  <div v-on="$listeners">
    <template v-for="(content, idx) in contents">
      <component
        v-if="content.hasOwnProperty('html')"
        v-html="content.html"
        :is="content.tag || 'span'"
        :key="idx"
      />

      <component
        v-else
        v-bind="filterAttributes(content)"
        v-on="content.listeners"
        :is="content.tag || 'span'"
        :key="idx"
      >
        {{ content.text }}
      </component>
    </template>
  </div>
</template>

<script>
export default {
  props: {
    /**
    NOTE:
    This prop is an array of objects that can contain any of the following:
    - tag: string - the tag name of the `component` to be rendered, defaults to `div`
    - text: string - text (children) inside the `component`
    - listeners: object - any event listeners that should be attached to the `component`
    - html: string - if this is defined, `text` and `listeners` will be ignored and this will be rendered as Raw HTML
    - any other prop that can be passed as DOM attributes to `component`

    `html` is used for rendering simple html like `<em>`, `<p>`, `<strong>`, etc.
    If you're using `html`:
    - SCSS styles will not be applied
    - `listeners` will not be applied
    - `text` will not be applied

    Example:
    this.$mcToast.success({
      component: 'McToastDynamicBody', // Required (notice the string), registered in `src/plugins/McToastAlertPlugin.js`
      props: {
        contents: [
          {
            tag: 'h1',
            text: 'Hello World',
            class: 'text-2xl',
          },
          {
            tag: 'p',
            text: 'This is a paragraph',
            class: 'text-base',
          },
          {
            tag: 'div',
            text: this.doNumber,
            data-do-number: this.doNumber,
            listeners: {
              click: (e) => {
                const doNumber = e.target.dataset.doNumber // or e.target.getAttribute('data-do-number')
                window.location.href = `/delivery/${doNumber}`
              },
            }
          },
          {
            tag: 'button',
            text: 'Click me',
            class: 'bg-blue-500 text-white',
            listeners: {
              click: () => {
                alert('Hello World')
              },
            },
          },
          {
            tag: 'img',
            src: 'https://picsum.photos/200/300',
          },
          {
            html: '<p>This is a paragraph with <strong>bold</strong> text</p>',
          },
        ],
      }
    })


    const clickListener = () => {
      this.$router.push({
        name: 'Delivery Detail',
        params: { id: deliveryOrder.id },
      })
    }
    this.$mcToast.success({
      component: 'McToastDynamicBody',
      props: {
        contents: [
          { tag: 'span', text: 'Berhasil mengeluarkan pengiriman' },
          {
            tag: 'a',
            text: `${deliveryOrder.number}`,
            class: '__link',
            listeners: { click: clickListener },
          },
        ],
      },
    })

    */
    contents: {
      type: Array,
      required: true,
    },
  },
  methods: {
    // Remove irrelevant props/attributes from content (text, tag, etc)
    // so that they won't be rendered in the DOM
  },
}
</script>
